import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";
import { tokens } from "../../Common/designTokens";
import { inputStyle } from "./styles";
import {
  defaultListName,
  LIST_RFQ_NAME_REQUIRED,
  MAX_LIST_RFQ_NAME_LENGTH,
} from "../../Constants/AppConstants";

/**
 * Asks for the list's name before a bond ladder is sent as one List RFQ ("Send List Order").
 * Prefilled with the protocol's default name; the trader may change or clear it (clearing is
 * allowed unless LIST_RFQ_NAME_REQUIRED is on).
 */
const ListNamePrompt = ({ open, protocol, onCancel, onSend }) => {
  const [listName, setListName] = useState(defaultListName(protocol));

  // A fresh default each time it opens, never the last list's name.
  useEffect(() => {
    if (open) setListName(defaultListName(protocol));
  }, [open, protocol]);

  const blocked = LIST_RFQ_NAME_REQUIRED && !listName.trim();

  return (
    <Modal open={open} onClose={onCancel} aria-labelledby="list-name-prompt">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 460,
          bgcolor: tokens.colors.bodyBackgroundColor,
          border: `1px solid ${tokens.colors.bodyBorderColor50}`,
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography id="list-name-prompt" variant="h6" sx={{ color: tokens.colors.fontColour }}>
          Send List Order
        </Typography>
        <TextField
          fullWidth
          autoFocus
          label="List Name"
          required={LIST_RFQ_NAME_REQUIRED}
          value={listName}
          onChange={(e) => {
            if (e.target.value.length <= MAX_LIST_RFQ_NAME_LENGTH) setListName(e.target.value);
          }}
          variant="filled"
          sx={inputStyle}
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <Typography
                variant="caption"
                sx={{ color: tokens.colors.fontColour80, whiteSpace: "nowrap", pointerEvents: "none" }}
              >
                {listName.length}/{MAX_LIST_RFQ_NAME_LENGTH}
              </Typography>
            ),
          }}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button variant="outlined" onClick={onCancel} sx={{ textTransform: "none", minWidth: 100 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => onSend(listName.trim() || null)}
            disabled={blocked}
            sx={{ textTransform: "none", minWidth: 100 }}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ListNamePrompt;
